import React from "react";
import { PegInformationModal as PegInformationModalCB } from "cb-design-system";

const PegInformationModal = (props) => {
  return <PegInformationModalCB {...props} />;
};

export default PegInformationModal;
